export default "/fonts/AvenirNextLTPro-Demi.ttf";